import { render, staticRenderFns } from "./CountrySwitchModal.vue?vue&type=template&id=45894409&"
import script from "./CountrySwitchModal.vue?vue&type=script&lang=js&"
export * from "./CountrySwitchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports